import axios from "axios";

const baseURL = process.env.API.TMF_URL;

/**
 * axiosの設定を定義します
 */
export default axios.create({
  baseURL: baseURL,
  // headers: {
  //   "Content-Type": "application/json",
  // },
  // responseType: "json",
  // withCredentials: true,
});



// WEBPACK FOOTER //
// ./src/api/Repository.js